import { call, put, takeLatest } from 'redux-saga/effects';
import * as api from '../../api';
import * as actions from './actions';
import { COUNTRY_COURSE_TYPE } from '../../constants';

export function* getCountryYearGroups(action) {
    const { countryCode,
        success = actions.getCountryYearGroupSuccess,
        failure = actions.getCountryYearGroupFailure } = action;

    const response = yield call(api.getCountryYearGroups, { countryCode });
    if (response.status === 200) {
        yield put(success(response.data));
    } else {
        yield put(failure());
    }
}

export function* getCountryYearGroupsSaga() {
    yield takeLatest(actions.GET_COUNTRY_YEAR_GROUPS_REQUEST, getCountryYearGroups);
}

export function* getYearGroup() {
    const payload = yield call(api.getYearGroups);
    if (payload.status === 200) {
        yield put(actions.getYearGroupSuccess(payload));
    } else {
        yield put(actions.getYearGroupFailure());
    }
}

export function* getYearGroupsSaga() {
    yield takeLatest(actions.GET_YEAR_GROUP_REQUEST, getYearGroup);
}

export function* getCourseCountry({ selectedProductId }) {
    const countriesRequest = { ProductId: selectedProductId };
    const response = yield call(api.getCourseCountries, countriesRequest);
    if (response.status === 200) {
        yield put(actions.getCourseCountrySuccess(response.data));
    } else {
        yield put(actions.getCourseCountryFailure());
    }
}

export function* getCourseCountrySaga() {
    yield takeLatest(actions.GET_COUNTRY_REQUEST, getCourseCountry);
}

export function* getUpfCourseCountry({ selectedProductId, countryCourseType = COUNTRY_COURSE_TYPE.UPF }) {
    const countriesRequest = { ProductId: selectedProductId, countryCourseType };
    const response = yield call(api.getUpfCourseCountries, countriesRequest);
    if (response.status === 200) {
        yield put(actions.getUpfCourseCountriesSuccess(response.data));
    } else {
        yield put(actions.getUpfCourseCountriesFailure());
    }
}

export function* getUpfCourseCountrySaga() {
    yield takeLatest(actions.GET_UPF_COUNTRY_REQUEST, getUpfCourseCountry);
}

export function* getProductCourse({ countryCode, productId, yearGroup }) {
    const countriesRequest = { countryCode, productId, yearGroup };
    const response = yield call(api.getProductCourses, countriesRequest);
    if (response.status === 200) {
        yield put(actions.getProductCourseSuccess(response.data));
    } else {
        yield put(actions.getProductCourseFailure());
    }
}

export function* getProductCourseSaga() {
    yield takeLatest(actions.GET_PRODUCT_COURSE_REQUEST, getProductCourse);
}

export function* getSchoolCourse({ yearGroup }) {
    const request = { yearGroup };
    const response = yield call(api.getSchoolCourses, request);
    if (response.status === 200) {
        yield put(actions.getSchoolCourseSuccess(response.data));
    } else {
        yield put(actions.getSchoolCourseFailure());
    }
}

export function* getSchoolCourseSaga() {
    yield takeLatest(actions.GET_SCHOOL_COURSE_REQUEST, getSchoolCourse);
}



// WEBPACK FOOTER //
// ./app/containers/assign-courses/saga.js